import { executeRequest, Request, Response } from '@jfs/network'
import { convertBoolValue, getImageUrlPath } from '../util/billPaymentUtil'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: Response) => {
  console.log('responseParserSearched', data)

  const responseData = data?.data?.responseObject ?? []
  const retData = responseData.map((item: any) => {
    const productTag = item?.product
    const standingInstructionTag = item?.standingInstruction
    return {
      id: item?.product?.id,
      autoPayAllow: convertBoolValue(standingInstructionTag?.autoPayAllow),
      categoryId: item?.category?.id,
      logoPath: getImageUrlPath(productTag?.logoName ?? ''),
      name: item?.category?.name,
      shortName: productTag?.displayName,
      type: productTag.type,
      isBbps: convertBoolValue(productTag?.isBbps),
      maxAmount: productTag.maxAmount,
      minAmount: productTag.minAmount,
      searchTags: productTag?.searchTags,
      partialPaymentAllow: convertBoolValue(productTag?.partialPaymentAllow),
      billFetchAllow: convertBoolValue(productTag?.billFetchAllow),
      isExistingBiller: false,
      fields: [],
      iDEBPP: item.billerIDEBPP ?? 0,
      circles: [],
      distributor: [],
      amountLov: item?.amountLov ?? '',
      nickNameField: {
        id: 0,
      },
    }
  })

  return retData
}

interface filter {
  State: String
  City: String
}

const bodyData = (offset: number, searchText: undefined | string, filters: filter) => {
  return {
    domain: {
      id: 'PayMyBill',
      name: 'PayMyBill',
      transactionType: 'BUY',
      description: 'This is for the buy case',
    },
    initiatingEntity: {
      entityId: 3131,
    },
    category: {
      id: '100018', //HARDCODED BECAUSE ONLY ONE BILLER IS THERE WITH THIS ID
    },
    searchDetails: {
      filters: {
        State: filters?.State,
        City: filters?.City,
      },
      searchText: searchText,
      offset: offset,
      limit: 20,
    },
  }
}

export const seachBillers = async (
  tokens: any,
  userAccessToken: any,
  filters: filter,
  searchText: string,
  pageNo: number,
) => {
  const offset = (pageNo - 1) * 20
  let mappedSearchText = ''
  if (searchText !== '') {
    mappedSearchText = searchText
  }
  const postBody = bodyData(offset, mappedSearchText, filters)
  const config = sitConfig(tokens)

  const request: Request<{}> = {
    apiPath: APIEndPoints.seachBillers,
    method: 'POST',
    body: postBody,
    config: config,
    headers: {
      'Content-Type': 'application/json',
      Authorization: userAccessToken,
    },
  }
  return executeRequest(request)
    .then(responseParser)
    .catch((error: any) => {
      throw error
    })
}
